/**
 * @generated SignedSource<<ca7bd0b567436a46d4cf5e73d36f8f76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PunchPassCalculationType = "PER_BOOKING" | "PER_SLOT";
export type PunchPassTemplateType = "RATE" | "TRANSPORTATION";
import { FragmentRefs } from "relay-runtime";
export type PunchPassListItem_PunchPass$data = {
  readonly client: {
    readonly fullName?: string;
  };
  readonly id: string;
  readonly punchPassTemplate: {
    readonly calculationType: PunchPassCalculationType;
    readonly name: string;
    readonly type: PunchPassTemplateType;
  };
  readonly remainingPunchCount: number;
  readonly " $fragmentType": "PunchPassListItem_PunchPass";
};
export type PunchPassListItem_PunchPass$key = {
  readonly " $data"?: PunchPassListItem_PunchPass$data;
  readonly " $fragmentSpreads": FragmentRefs<"PunchPassListItem_PunchPass">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PunchPassListItem_PunchPass",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingPunchCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "Member",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "Customer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "punchPassTemplate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "calculationType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PunchPass",
  "abstractKey": null
};
})();

(node as any).hash = "4d786a16702446827607e8b71640031f";

export default node;
